/*
 * Find my size — imperial by default (UK audience), toggle to metric.
 *
 * Height and weight are each matched to a size independently (the size
 * whose range contains the value, or the nearest end of the chart if the
 * value falls outside every range), then the LARGER of the two sizes wins.
 * That guarantees someone whose weight (or height) is already past the top
 * of the chart is never recommended anything smaller than the largest size
 * available — nobody gets sized down just because one measurement pulled
 * the average toward a smaller size.
 */
(function () {
  var SIZES = [
    { key: 'S',   hMinCm: 160, hMaxCm: 170, wMinKg: 43, wMaxKg: 54 },
    { key: 'M',   hMinCm: 165, hMaxCm: 175, wMinKg: 54, wMaxKg: 64 },
    { key: 'L',   hMinCm: 170, hMaxCm: 180, wMinKg: 64, wMaxKg: 73 },
    { key: 'XL',  hMinCm: 175, hMaxCm: 185, wMinKg: 75, wMaxKg: 82 },
    { key: 'XXL', hMinCm: 185, hMaxCm: 195, wMinKg: 82, wMaxKg: 86 }
  ];

  function cmFromFtIn(ft, inch) {
    var totalIn = (ft || 0) * 12 + (inch || 0);
    return totalIn * 2.54;
  }
  function kgFromLb(lb) {
    return (lb || 0) * 0.453592;
  }

  // Returns the index (into SIZES) of the size whose [min,max] range covers
  // `value`. If value is below every range, returns 0 (the smallest size).
  // If value is above every range, returns the last index (the largest size).
  function indexForValue(value, minKey, maxKey) {
    for (var i = 0; i < SIZES.length; i++) {
      if (value <= SIZES[i][maxKey]) return i;
    }
    return SIZES.length - 1;
  }

  function bestMatch(heightCm, weightKg) {
    var byHeight = indexForValue(heightCm, 'hMinCm', 'hMaxCm');
    var byWeight = indexForValue(weightKg, 'wMinKg', 'wMaxKg');
    var index = Math.max(byHeight, byWeight);
    return SIZES[index];
  }

  function init(root) {
    if (root.dataset.sdSizeReady === '1') return;
    root.dataset.sdSizeReady = '1';

    var toggle = root.querySelector('[data-sd-size-toggle]');
    var chartToggle = root.querySelector('[data-sd-chart-toggle]');
    var unitBtns = root.querySelectorAll('[data-sd-unit]');
    var imperialFields = root.querySelector('[data-sd-imperial-fields]');
    var metricFields = root.querySelector('[data-sd-metric-fields]');
    var result = root.querySelector('[data-sd-size-result]');
    var resultValue = root.querySelector('[data-sd-size-result-value]');
    var unit = 'imperial';

    toggle.addEventListener('click', function () {
      root.classList.toggle('is-open');
      root.classList.remove('is-chart-open');
    });

    chartToggle.addEventListener('click', function () {
      root.classList.toggle('is-chart-open');
      root.classList.remove('is-open');
    });

    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        unit = btn.dataset.sdUnit;
        unitBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        if (unit === 'imperial') {
          imperialFields.style.display = '';
          metricFields.style.display = 'none';
        } else {
          imperialFields.style.display = 'none';
          metricFields.style.display = '';
        }
        compute();
      });
    });

    function readInputs() {
      var heightCm, weightKg;
      if (unit === 'imperial') {
        var ft = parseFloat(root.querySelector('[data-sd-height-ft]').value);
        var inch = parseFloat(root.querySelector('[data-sd-height-in]').value);
        var lb = parseFloat(root.querySelector('[data-sd-weight-lb]').value);
        if (isNaN(ft) && isNaN(inch)) return null;
        if (isNaN(lb)) return null;
        heightCm = cmFromFtIn(ft || 0, inch || 0);
        weightKg = kgFromLb(lb);
      } else {
        var cm = parseFloat(root.querySelector('[data-sd-height-cm]').value);
        var kg = parseFloat(root.querySelector('[data-sd-weight-kg]').value);
        if (isNaN(cm) || isNaN(kg)) return null;
        heightCm = cm;
        weightKg = kg;
      }
      return { heightCm: heightCm, weightKg: weightKg };
    }

    function compute() {
      var vals = readInputs();
      if (!vals) {
        result.style.display = 'none';
        return;
      }
      var match = bestMatch(vals.heightCm, vals.weightKg);
      result.style.display = 'block';
      resultValue.textContent = match.key;
    }

    root.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('input', compute);
    });
  }

  function boot() {
    document.querySelectorAll('[data-sd-size]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
